import { render } from "./AuthLayout.vue?vue&type=template&id=773eb67d"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"

import "./AuthLayout.vue?vue&type=style&index=0&id=773eb67d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__